import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'

export default {
  data() {
    return {
      height: 120
    }
  },
  mounted() {
    this.resize()
    addResizeListener(this.$el, this.resize)
    // window.addEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      this.height = this.$el.offsetHeight
    }
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.resize)
    // window.removeEventListener('resize', this.resize)
  }
}
